import { Button, Chip, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { variants } from '../../../../variants/variants';
import UserAvatar from '../../../../common/UserAvatar';
import { Box } from '@mui/material';
import { ArrowRightAltRounded, EventAvailable, RateReviewRounded } from '@mui/icons-material';
import { useTheme } from '@emotion/react';
import { format } from 'date-fns';
import { boxBackground, colors } from '../../utility/status';
import { useSelector } from 'react-redux';
import { selectShowAdminHistory, selectShowSubmittedHistory } from '../../giftSlice';

const CustomHistoryRow = ({ gift, showEmployee }) => {
  const currentDesignation = gift[2]?.split(' - ')[0];
  const desiredDesignation = gift[3]?.split(' - ')[0];
  const user = gift[1];
  const submitted = gift[4];
  const result = gift[5];
  const reason = gift[6];
  const adminHistory = useSelector(selectShowAdminHistory);
  const managerHistory = useSelector(selectShowSubmittedHistory);
  const isHistory = Boolean(adminHistory || managerHistory);
  const theme = useTheme();

  return (
    <Stack direction={'row'} alignItems={'center'}>
      {showEmployee && <UserAvatar src={user?.employeePhotoPath} sx={{ mr: 1 }} />}

      <Box>
        <Typography sx={{ fontSize: variants.TINY }}>{user?.empName}</Typography>
        <Stack direction={'row'} alignItems={'center'} sx={{ mb: 0.5 }}>
          <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main }}>
            {currentDesignation}
          </Typography>
          <ArrowRightAltRounded />
          <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main }}>
            {desiredDesignation}
          </Typography>
        </Stack>
        <Typography sx={{ fontSize: variants.TINY }}>{format(new Date(submitted), 'PP')}</Typography>
      </Box>
      <Stack sx={{ ml: 'auto' }}>
        {reason && !isHistory && (
          <Typography
            sx={{
              fontSize: variants.TINY,
              color: colors.Pass,
            }}
          >
            Feedback provided
          </Typography>
        )}
        <Chip
          size='small'
          sx={{ background: boxBackground[result], color: colors[result], fontWeight: 700 }}
          label={result}
        />
      </Stack>
    </Stack>
  );
};
export default CustomHistoryRow;
